import styled from 'styled-components'

/* Full-height flex-column wrapper for the CEV page. `.inner-content`
   (HomePage.css) already constrains height to `calc(100vh - 73px)`
   and scrolls by default; this container fills that box exactly,
   hides its own overflow, and lets `View` absorb whatever vertical
   space the Menu doesn't claim. That way only the inner CasesTable
   scrolls — the parent `.inner-content` stays pinned. */
export const Page = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
`

export const View = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    /* flex: 1 claims the remaining height after Menu; min-height: 0
       is required so the flex child is allowed to shrink below its
       content's intrinsic size, which in turn lets
       CasesTableContainer's overflow-y: auto activate. */
    flex: 1;
    min-height: 0;
    background: #fff;
    position: relative;
    overflow: hidden;
`

